export const columns = [
  { field: 'name', label: 'Name' },
  { field: 'email', label: 'Email' },
  { field: 'phone', label: 'Phone Number' },
  {
    field: 'role', label: 'Role', 
  },
  { field: 'preferred', label: 'Preferred By' },
  {
    field: 'order_status', label: 'Status'
  },
  { field: 'action', label: 'Action' }
]

export const rows = [
  {
    id: "123",
    name: "Rutuja Patil",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    role: "Delivery Partner",
    status: "Active",
    type:"Store"
  },
  {
    id: "224",
    name: "Priya",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "333",
    name: "Kunal Saxena",
    email: "natalie.smith@gmail.com",
    phone: "+1123659870",
    role: "user",
    status: "Inactive",
    type:"Delivery"
  },
  {
    id: "434",
    name: "Mohit",
    email: "Emily.chen@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Inactive",
    type:"Delivery"
  },
  {
    id: "544",
    name: "Sarah Thompson",
    email: "john.de@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "655",
    name: "James Anderson",
    email: "natalie.smith@gmail.com",
    phone: "+1321888123",
    role: "Delivery Partner",
    status: "Inactive",
    type:"Delivery"
  },
    {
    id: "1231",
    name: "Rutuja Patil",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    role: "Delivery Partner",
    status: "Active",
    type:"Store"
  },
  {
    id: "2241",
    name: "Priya",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "331",
    name: "Kunal Saxena",
    email: "john.de@gmail.com",
    phone: "+1123659870",
    role: "user",
    status: "Inactive",
    type:"Store"
  },
  {
    id: "4341",
    name: "Mohit",
    email: "john.de@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Inactive",
    type:"Delivery"
  },
  {
    id: "5441",
    name: "Sarah Thompson",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "6551",
    name: "James Anderson",
      email: "john.de@gmail.com",
    phone: "+1321888123",
    role: "Delivery Partner",
    status: "Inactive",
    type:"Delivery"
  },
    {
    id: "1232",
    name: "Rutuja Patil",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    role: "Delivery Partner",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "2243",
    name: "Priya",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "3331",
    name: "Kunal Saxena",
    email: "Emily.chen@gmail.com",
    phone: "+1123659870",
    role: "user",
    status: "Inactive",
    type:"Delivery"
  },
  {
    id: "4341",
    name: "Mohit",
    email: "lily.rivera@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Inactive",
    type:"Delivery"
  },
  {
    id: "5443",
    name: "Sarah Thompson",
    email: "sarah.t90@gmail.com",
    phone: "+1284794893",
    role: "Bussiness",
    status: "Active",
    type:"Delivery"
  },
  {
    id: "6558",
    name: "James Anderson",
    email: "lily.rivera@gmail.com",
    phone: "+1321888123",
    role: "Delivery Partner",
    status: "Inactive",
    type:"Store"
  },
];


export const serviceColumns = [
  { field: "serviceType", label: "Service Type" },
  { field: "category", label: "Category" },
  { field: "unit", label: "Unit" },
  { field: "price", label: "Price" },
  { field: "description", label: "Description" }
];

export const serviceRows = [
  {
    service: "Gents Wear",
    category: "Laundery",
    unit: "Per Person",
    price: "$300",
    type: "Basic",
    description: "Women's haircut and styling"
  },
  {
    service: "Womens Haircut",
    category: "Salon",
    unit: "60 mins",
    price: "$1500",
    type: "Premium",
    description: "Women's haircut and styling"
  }
];
